<template>
  <button :class="className" @click="logout">
    Sign out
  </button>
</template>
<script>
import moment from 'moment'
export default {
  name: "Header",
  props:["className"],
  data() {
    return {
      dashboard: false,
      employee: false,
      profile_nav:false,
      company_profile:false,
      salary_calc_nav: false,
      comp_profile_nav:false,
      reports_nav:false,
      upgrade_membership:false,
      leave_nav:false,
      messages_nav:false,
      timesheet_nav:false,
      user_id: (this.$store.getters.getUser)?this.$store.getters.getUser.id:'',
    };
  },

  methods: {
    logout() {
      return this.$axios
        .get(this.$Logout, {
          headers: this.getAuthHeader()
        })
        .then(response => {
            localStorage.setItem('isLogin', 0);

          localStorage.setItem('companyEmployees', JSON.stringify(null));
          this.$store.commit("logoutUser");
          this.$router.push({ name: "login" });
        })
        .catch(error => {
          console.log(error);

        });
    },

  }
};
</script>
